'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function inRange(minRange, maxRange, props, propName) {
  var number = props[propName];

  // TODO Find why the Spanel build is failing when we use template instead of string concatenation
  /* eslint-disable */
  if (number < minRange || number > maxRange) {
    return new Error(propName + ' should be between ' + minRange + ' and ' + maxRange + ', but it is ' + number);
  }

  return null;
}

exports.inRange = inRange;
/* eslint-enable */